import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import ExportApi from "../api/ExportApi";
import { toast } from "react-toastify";

const SetupPayout = () => {
    const [searchParams] = useSearchParams();
    const userId = searchParams.get("userId");
    const email = searchParams.get("email");

    useEffect(() => {
        if (!userId || !email) return;
        ExportApi.handleCard(userId, email, "bidask")
            .then((resp) => {
                if (
                    resp.data.data.link
                ) {
                    const data = resp.data.data;
                    window.location.href = data.link;
                } else {
                    toast.error(resp.data.message);
                }
            })
            .catch((err) => {
                toast.error("Something went wrong, Please try again");
            });
    }, []);

    return (
        <div style={{ padding: 20 }}>
            <h2>Loading Stripe Payout Setup...</h2>
            <p>Please wait while we redirect you.</p>
        </div>
    );
};

export default SetupPayout;
